import React from 'react';
import type { TutorialStepT } from '../../../common/types/types';
const drawCuboid = {
  version: 1,
  id: 'draw-cuboid',
  render: () => <div>Drag on the screen to draw face of cuboid.</div>,
  disableNext: true,
  nextId: 'end-polygon'
};
const endCuboid = {
  version: 1,
  id: 'end-cuboid',
  render: () => <div>Use mouse to move and click to place the face of cuboid.</div>,
  disableNext: true
};
export const CUBOID_TUTORIAL_CONFIG: { [name in 'drawCuboid' | 'endCuboid']: Omit<TutorialStepT, 'getTarget'> } = {
  drawCuboid: {
    ...drawCuboid,
    nextId: endCuboid.id
  },
  endCuboid
};